import React, { useContext } from 'react';

import { VerifyPersonalInfoContents } from '../../components';
import { IdentityProvider } from '../../context';
import { useScrollToTop } from '../../hooks';

import { NewPOAContext } from './new-poa-composer';

export function NewPOAPersonalInfo() {
  const { update } = useContext(NewPOAContext);
  useScrollToTop();

  return (
    <IdentityProvider>
      <VerifyPersonalInfoContents 
        resource="power_of_attorney" 
        steps={6} 
        nextPath="../choosing-agent" 
        payload={{
          state_of_residence: 'TX'
        }}
        updateEntity={update}
      />
    </IdentityProvider>
  );
}
